let interfaceToast = {
  "loginTimeout": "登录超时请重新登录",
  "interfaceError": "错误码\"&&\"， 请联系系统管理员",
  "networkError": "网络连接失败请稍后再试",
}
export default interfaceToast;



// WEBPACK FOOTER //
// ./src/i18n/interfaceToast-zh-CN.js